import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import DropdownMain from "../../../../../../components/dropdown-main/DropdownMain";
import GeneralProperties from "../../../../../../assets/icons/Icon-Window-Bullet-List-Blue-16px.svg";

const GeneralPropertiesSection = ({
  workflowBasic,
  setWorkflowBasic,
  initialStatusList,
  onInitialStatusSelect,
}) => {
  return (
    <div className="workflow-section-panel">
      <div className="workflow-section-description">
        <img src={GeneralProperties} alt="General Properties" />
        General Properties
      </div>
      <div className="workflow-section-body">
        <Form>
          <Form.Row className="left-row">
            <Form.Group className="user-full-name">
              <Form.Label>
                Workflow Name <span style={{ color: "red" }}> * </span>
              </Form.Label>
              <Form.Control
                id="userNameFull"
                name="userNameFull"
                placeholder="Enter Workflow Name"
                value={workflowBasic?.Name || ""}
                onChange={(e) => setWorkflowBasic({ ...workflowBasic, Name: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="description">
              <Form.Label>Workflow Description</Form.Label>
              <Form.Control
                id="description"
                name="description"
                autoComplete="off"
                placeholder="Enter workflow description"
                className="project-textarea textarea"
                value={workflowBasic?.Description || ""}
                onChange={(e) => setWorkflowBasic({ ...workflowBasic, Description: e.target.value })}
                as="textarea"
                rows="3"
              />
            </Form.Group>

            <Form.Label>
              Start Workflow From <span style={{ color: "red" }}> * </span>
            </Form.Label>
            <DropdownMain
              values={(initialStatusList || []).map((o) => o)}
              dropdownButtonText={"Select Initial Status"}
              onSelect={onInitialStatusSelect}
              currentSelected={workflowBasic?.InitialStatus}
            />
          </Form.Row>
        </Form>
      </div>
    </div>
  );
};

GeneralPropertiesSection.propTypes = {
  workflowBasic: PropTypes.object.isRequired,
  setWorkflowBasic: PropTypes.func.isRequired,
  initialStatusList: PropTypes.array.isRequired,
  onInitialStatusSelect: PropTypes.func.isRequired,
};

export default GeneralPropertiesSection;
